import React, { createContext, useContext, useEffect, useState } from "react";
import { fetchApi } from "../config";

const SocialContext = createContext({ social: [], loading: true, error: null });

export function SocialProvider({ children }) {
  const [social, setSocial] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let mounted = true;
    async function load() {
      try {
        const res = await fetchApi("get_social_media.php");
        if (!mounted) return;
        if (res && Array.isArray(res.SocialMedia)) {
          setSocial(res.SocialMedia);
        } else {
          setSocial([]);
        }
      } catch (err) {
        if (!mounted) return;
        setError(err.message || "Failed to load social media links");
      } finally {
        if (!mounted) return;
        setLoading(false);
      }
    }
    load();
    return () => { mounted = false; };
  }, []);

  return (
    <SocialContext.Provider value={{ social, loading, error }}>
      {children}
    </SocialContext.Provider>
  );
}

export function useSocial() {
  return useContext(SocialContext);
}
